module.exports = "/assets/archetype-help.webp"